class AvailablePathService {
  constructor (http) {
    this.http = http
  }

  async getDistance (availablePath, incotermId) {
    const result = await this.http.get(`/available-paths/distance?OriginCountryId=${availablePath.originCountryId}&DestinationCountryId=${availablePath.destinationCountryId}&OriginTerminalId=${availablePath.originTerminalId}&OriginCityId=${availablePath.originCityId}&DestinationTerminalId=${availablePath.destinationTerminalId}&DestinationCityId=${availablePath.destinationCityId}&TransportMode=${availablePath.transportMode}&IncotermId=${incotermId}`)
    return result.data
  }

  async getTotalCosts (input, incotermId) {
    const result = await this.http.post(`/available-paths/total-cost?IncotermId=${incotermId}`, input)
    return result.data
  }
}

export default AvailablePathService
